function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".monitoring-icon{fill:url(#monitoring);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "monitoring",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F66614"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "monitoring-icon",
  d: "M38,3A22.984,22.984,0,0,0,20.129,40.457L17.986,42.6a2.965,2.965,0,0,0-1.965-.751H16a2.98,2.98,0,0,0-2.131.909L2.767,54.182l7.052,7.05,11.423-11.1a2.977,2.977,0,0,0,.158-4.118l2.143-2.143A22.994,22.994,0,1,0,38,3ZM19.848,48.7,9.838,58.424,5.576,54.162,15.3,44.152a1,1,0,0,1,.711-.3.9.9,0,0,1,.714.293l3.13,3.13a1,1,0,0,1-.01,1.425ZM20,44.586,19.414,44l2.044-2.044q.288.3.586.586ZM38,47A21,21,0,1,1,59,26,21.024,21.024,0,0,1,38,47Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "monitoring-icon",
  d: "M38,7A19,19,0,1,0,57,26,19.021,19.021,0,0,0,38,7Zm0,36A17,17,0,1,1,55,26,17.019,17.019,0,0,1,38,43Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "monitoring-icon",
  d: "M38,17a15.386,15.386,0,0,0-10.95,4.535L22.586,26l4.464,4.465a15.487,15.487,0,0,0,21.9,0L53.414,26,48.95,21.535A15.386,15.386,0,0,0,38,17Zm7,9a7,7,0,1,1-7-7A7.008,7.008,0,0,1,45,26ZM25.414,26l3.05-3.051a13.606,13.606,0,0,1,1.771-1.478,8.922,8.922,0,0,0,0,9.058,13.606,13.606,0,0,1-1.771-1.478Zm22.122,3.051a13.606,13.606,0,0,1-1.771,1.478,8.922,8.922,0,0,0,0-9.058,13.606,13.606,0,0,1,1.771,1.478L50.586,26Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "monitoring-icon",
  d: "M38,31a5,5,0,1,0-5-5A5.006,5.006,0,0,0,38,31Zm0-8a3,3,0,1,1-3,3A3,3,0,0,1,38,23Z"
});

function SvgMonitoring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.bf3cbede.svg";
export { ForwardRef as ReactComponent };